var _ellipse, _text, _text2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 130",
    role: "img",
    "aria-label": "Powerline Engineers",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 65,
    rx: 104,
    ry: 59,
    fill: "#fff",
    stroke: "#111214",
    strokeWidth: 7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 88,
    fontFamily: "Georgia,'Times New Roman',serif",
    fontWeight: 700,
    fontSize: 76,
    fill: "#111214"
  }, "P")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 88,
    fontFamily: "Georgia,'Times New Roman',serif",
    fontWeight: 700,
    fontSize: 76,
    fill: "#111214"
  }, "E")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 18 L88 66 L108 66 L72 112 L132 58 L112 58 Z",
    fill: "#D0201C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30623ce055b8a12a84aafa6588d25116.svg";
export { ForwardRef as ReactComponent };